@for (toast of toastService.toasts(); track toast) {
  <ngb-toast
    [class]="toast.classname"
    [header]="toast.header || ''"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)"
  >
    @if (toast.template) {
      <ng-template [ngTemplateOutlet]="toast.template" [ngTemplateOutletContext]="{ toast: toast }"></ng-template>
    } @else if (toast.message) {
      <p>{{ toast.message | translate }}</p>

      <div class="d-flex gap-2">
        <a
          href="javascript: void(0)"
          class="fw-bold text-uppercase {{ toast.buttonClassname }}"
          (click)="closeToast(toast)"
        >
          {{ 'buttons.ok' | translate }}
        </a>
      </div>
    }
  </ngb-toast>
}
